export * from './IconToolsGradient';
export { default as IconToolsGradient } from './IconToolsGradient';
